import { GetServerSidePropsContext } from 'next'
import { getBucket } from '@mc/next-growthbook'
import { paths } from '@mc/paths'
import { RegularFooter } from 'components/Footer/RegularFooter'
import { CoreNavigation } from 'components/Navigation/consumer'
import { GladlyHelpCenterHub } from './components/GladlyHelpCenterHub'
import { helpCenterLayout } from './components/ui'
import { refreshHelpCenterAnonUuidCookie } from './helpCenterUuidCookie'
import { HelpCenterProduct, productsByKey } from './utils'

interface HelpCenterPageProps {
  products: HelpCenterProduct[]
}

const HelpCenterPage = ({ products }: HelpCenterPageProps) => (
  <GladlyHelpCenterHub products={products} />
)

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const onCallProductEnabled =
    (await getBucket(ctx, 'gladly_help_center_on_call')) === 'on'
  const executiveProductEnabled =
    (await getBucket(ctx, 'gladly_help_center_educator')) === 'on'

  // SUPPORT LEGACY URLS - from before we had a by-product help center
  if (ctx.query.a) {
    return {
      redirect: {
        destination: paths.helpCenterAnswer(
          productsByKey.CORE.slug,
          ctx.query.a as string,
        ),
        permanent: true,
      },
    }
  }

  refreshHelpCenterAnonUuidCookie(ctx)

  const products = [
    productsByKey.CORE,
    productsByKey.CERTIFICATES,
    ...(executiveProductEnabled ? [productsByKey.EXECUTIVE] : []),
    ...(onCallProductEnabled ? [productsByKey.ON_CALL] : []),
    productsByKey.AT_WORK,
  ]

  return {
    props: {
      products,
    },
  }
}

HelpCenterPage.pageSettings = {
  analyticsLabel: 'Help Center',
  rumLabel: 'Help Center',
  title: 'Help Center | MasterClass',
  navigation: CoreNavigation,
  footer: RegularFooter,
}

HelpCenterPage.getLayout = helpCenterLayout({ withSearch: false })

export default HelpCenterPage
